<!-- Last Module 6-->
<div *ngIf="!courseComplete &&  page < 5">
    <div>

        <!-- Title -->
        <div class="text-center">
            <h1>Module 6 - When You Move Out</h1>
        </div>

        <!-- Module Content -->
        <section>
            <div *ngIf="page===1">
                <div class="container content-box module-content">


                    <!-- EDIT PAST THIS LINE -->


                    <h2>When You Move Out</h2>
                    <i>How you move out of your current unit affects the reference your landlord gives you when you look for a new place. This section explains the rules and expectations. When moving, some renters ask the landlord for a letter or certificate of rent paid.</i>
                    <br>
                    <h3>Security Deposit Guidelines</h3>
                    <p>Disputes over security deposits are a common problem between landlords and tenants. There are a number of actions tenants can take while they are moving in to avoid disputes over security deposits when they move out.</p>
                    <li class="bullet-point">Your unit should be clean when you move in and clean when you move out. Have the landlord or property manager walk through the unit with you. If appropriate, the landlord or manager should sign a statement saying the unit is clean
                        and undamaged. Keep the statement in your <span class="CharOverride-15">Organizer</span> in case of a dispute over the return of your security deposit.</li>
                    <br>
                    <li class="bullet-point">Nebraska law requires that security deposits (minus damages if applicable) be returned within 14 days of termination of the rental agreement. Landlords must send the security deposit to the tenant’s last known mailing address. If a
                        mailed check is “returned to sender” the landlord is required to turn over the balance of the security deposit to the State Treasurer to be treated as unclaimed property.</li>
                    <br>
                    <li class="bullet-point">Landlords are not supposed to deduct for normal wear and tear to a unit. However, it is sometimes difficult to say what is normal and what is caused by neglect. Preserving pictures of the unit when you moved in along with your completed
                        <span class="CharOverride-15"> Rental Condition Checklist</span> will help you settle a dispute.
                    </li>
                    <br>
                    <li class="bullet-point">Tenants cannot use the security deposit to cover rent. However, if a tenant fails to pay the rent, a landlord may keep the deposit to cover it.</li>


                    <!-- DON'T EDIT PAST THIS LINE -->


                </div>
                <div class="container navigate-buttons">
                    <button type="button" class="btn waves-dark w-25" [routerLink]="'/RentWise'"><i class="fas fa-angle-left mr-3"></i>Previous</button>
                    <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="15" [delay-tooltip]="true">Next<i class="fas fa-angle-right ml-3"></i></button>
                </div>
            </div>
        </section>

        <section>
            <div *ngIf="page===2">
                <div class="container module-content content-box">


                    <!-- EDIT PAST THIS LINE -->


                    <h2>Eviction and Notice</h2>
                    <h4>7-day Notice to Quit</h4>
                    <p>A 7-day notice is the way a landlord lets you know you are behind in rent. The notice must state the amount of rent you have to pay; that you have 7 days to pay the amount due; and that unless you pay the rent in full within 7 days,
                        your lease will terminate. A landlord may send a 7-day notice in the mail, hand it to the tenant in person or leave it on their door. To remedy, you must pay your rent in full plus any late fees within 7 days. You must pay the
                        entire amount of back due rent within these 7 days or the landlord may file a court case to evict you. If you pay the entire back rent due within the 7 days, the landlord must accept it and you can continue to stay in the unit.</p>
                    <h4>14-30 Day Notice to Quit</h4>
                    <p>Termination for violation (breach) of the lease other than nonpayment of rent: You might receive a notice from your landlord that says you violated the lease or rental agreement. You probably do not need to move yet. The letter may
                        be called a “14-30 Day Notice.” Landlords give this kind of notice when you are doing something that is not allowed under the lease; you are doing something that affects health or safety of other tenants; or If you need to make
                        repairs to the unit. The notice must give you 14 days to fix the problem. The 14 days begins to run on the day you get the notice. The lease will end in 30 days if you do not fix the problem within those 14 days. If you have a
                        month-to-month rental agreement, a landlord can end a rental agreement by giving you a notice to terminate. This notice must be given at least 30 days prior to the date when rent is due. Even if the lease ends your landlord cannot
                        lock you out of your apartment or lock up your property without first going to court and evicting you.</p>

                    <h4>5 Day Notice to Quit</h4>
                    <p>A 5-day notice to quit is given when you or a guest engage in criminal activity in your rental unit. If you receive a 5-day notice you have 5 days to leave vacate apartment and there is no right to cure.</p>
                    <p>An eviction results in a long-term court record which future landlords may check when you apply for housing.</p>
                    <br>
                    <p>If the tenant’s property is removed and stored, the tenant may have to pay reasonable costs for removal, transport, and storage. You have seven days from a direct written notice given to you (or 14 days from the written notice postmark
                        date) stating that your property is being stored and where to pick it up. After the seven days or 14 days, if you have not picked up the property and paid any storage fees, the landlord can sell your property at a public sale and
                        return the dollars minus the storage and sale costs. </p>
                    <br>
                    <p>Landlords are required to give written notice 30 days before the lease terminates and they want you to vacate. </p>
                    <h4>For more explanation about landlord and tenants regulations, check the following Web sites or contact a lawyer or legal aid. </h4>
                    <p>Nebraska State Statues: Article 14, Landlord and Tenant Uniform Residential Landlord Tenant Act, available at <a href="https://www.nrec.nebraska.gov/legal/landlordacttoc.html">www.nrec.state.ne.gov/legal/landlordacttoc.html.</a></p>
                    <p>Legal Aid of Nebraska Landlord and Tenant Handbook, available at <a href="https://www.legalaidofnebraska.org/wp-content/uploads/2019/05/Landlord-and-Tenant-handbook-2017.pdf">https://www.legalaidofnebraska.org/wp-content/uploads/2019/05/Landlord-and-Tenant-handbook-2017.pdf.</a></p>


                    <!-- DON'T EDIT PAST THIS LINE -->


                </div>
                <div class="container navigate-buttons">
                    <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                    <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="45" [delay-tooltip]="true">Next<i class="fas fa-angle-right ml-3"></i></button>
                </div>
            </div>
        </section>

        <section>
            <div *ngIf="page===3">
                <div class="container module-content content-box">
                    <!-- Start Activity 7 -->
                    <div id="activity1">
                        <h2>Activity: Moving On Quiz </h2>
                        <div class="radio wrapper">
                            <!-- 1 -->
                            <div class="question1">
                                <br> <b> Landlords can return security deposits at their convenience.</b> <br>
                                <input id="question1_true" name="question1" type="radio" [value]="true" [(ngModel)]="model7.model7_Q1" (click)="m7_Q1()"> <label for="question1_true">True</label><br/>
                                <input id="question1_false" name="question1" type="radio" [value]="false" [(ngModel)]="model7.model7_Q1" (click)="m7_Q1()"> <label for="question1_false">False</label><br/>
                                <div *ngIf="model7.model7_Q1 && model7_Q1" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                                    &nbsp;Nebraska requires it must be returned within 14 days of lease termination
                                </div>
                                <div *ngIf="!model7.model7_Q1  && model7_Q1" style="background-color: rgba(0, 128, 0, 0.25);font-weight: bolder;">
                                    &nbsp;Correct!
                                </div>
                            </div>

                            <!-- 2 -->
                            <div class="question2">
                                <br> <b>Landlords are allowed to deduct for normal wear on carpet when a tenant moves out</b> <br>
                                <input id="question2_true" name="question2" type="radio" [value]="true" [(ngModel)]="model7.model7_Q2" (click)="m7_Q2()"> <label for="question2_true">True</label><br/>
                                <input id="question2_false" name="question2" type="radio" [value]="false" [(ngModel)]="model7.model7_Q2" (click)="m7_Q2()"> <label for="question2_false">False</label><br/>
                                <div *ngIf="model7.model7_Q2 && model7_Q2" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                                    &nbsp;Landlords are not supposed to deduct charges for normal wear and tear to a unit.
                                </div>
                                <div *ngIf="!model7.model7_Q2  && model7_Q2" style="background-color: rgba(0, 128, 0, 0.25);font-weight: bolder;">
                                    &nbsp;Correct!
                                </div>
                            </div>

                            <!-- 3 -->
                            <div class="question3">
                                <br> <b> If you move out early, the security deposit serves as the last month's rent.</b> <br>
                                <input id="question3_true" name="question3" type="radio" [value]="true" [(ngModel)]="model7.model7_Q3" (click)="m7_Q3()"> <label for="question3_true">True</label><br/>
                                <input id="question3_false" name="question3" type="radio" [value]="false" [(ngModel)]="model7.model7_Q3" (click)="m7_Q3()"> <label for="question3_false">False</label><br/>
                                <div *ngIf="model7.model7_Q3 && model7_Q3" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                                    &nbsp;Tenants cannot use the security deposit to cover rent.
                                </div>
                                <div *ngIf="!model7.model7_Q3  && model7_Q3" style="background-color: rgba(0, 128, 0, 0.25); font-weight: bolder;">
                                    &nbsp;Correct!
                                </div>
                            </div>

                            <!-- 4 -->
                            <div class="question4">
                                <br> <b>Leases automatically end unless the landlord gives notice of intent to renew.</b> <br>
                                <input id="question4_true" name="question4" type="radio" [value]="true" [(ngModel)]="model7.model7_Q4" (click)="m7_Q4()"> <label for="question4_true">True</label><br/>
                                <input id="question4_false" name="question4" type="radio" [value]="false" [(ngModel)]="model7.model7_Q4" (click)="m7_Q4()"> <label for="question4_false">False</label><br/>
                                <div *ngIf="model7.model7_Q4 && model7_Q4" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                                    &nbsp;In Nebraska, at the end of a lease period when there is no intent to renew or evict, leases convert into a month-to-month lease.
                                </div>
                                <div *ngIf="!model7.model7_Q4  && model7_Q4" style="background-color: rgba(0, 128, 0, 0.25);font-weight: bolder;">
                                    &nbsp;Correct!
                                </div>
                            </div>

                            <!-- 5 -->
                            <div class="question5">
                                <br> <b> Tenants must leave the unit clean.</b> <br>
                                <input id="question5_true" name="question5" type="radio" [value]="false" [(ngModel)]="model7.model7_Q5" (click)="m7_Q5()"> <label for="question5_true">True</label><br/>
                                <input id="question5_false" name="question5" type="radio" [value]="true" [(ngModel)]="model7.model7_Q5" (click)="m7_Q5()"> <label for="question5_false">False</label><br/>
                                <div *ngIf="model7.model7_Q5 && model7_Q5" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                                    &nbsp;The unit should be clean when you move in and when you move out.
                                </div>
                                <div *ngIf="!model7.model7_Q5  && model7_Q5" style="background-color: rgba(0, 128, 0, 0.25);font-weight: bolder;">
                                    &nbsp;Correct!
                                </div>
                            </div>

                            <!-- 6 -->
                            <div class="question6">
                                <br> <b> Tenants cannot be evicted during the winter. </b> <br>
                                <input id="question6_true" name="question6" type="radio" [value]="true" [(ngModel)]="model7.model7_Q6" (click)="m7_Q6()"> <label for="question6_true">True</label><br/>
                                <input id="question6_false" name="question6" type="radio" [value]="false" [(ngModel)]="model7.model7_Q6" (click)="m7_Q6()"> <label for="question6_false">False</label><br/>
                                <div *ngIf="model7.model7_Q6 && model7_Q6" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                                    &nbsp;Weather does not affect evictions. However, with utilities it may be a factor.
                                </div>
                                <div *ngIf="!model7.model7_Q6  && model7_Q6" style="background-color: rgba(0, 128, 0, 0.25);font-weight: bolder;">
                                    &nbsp;Correct!
                                </div>
                            </div>

                            <!-- 7 -->
                            <div class="question7">
                                <br> <b> All tenants have a lease agreement whether verbal or in writing.</b> <br>
                                <input id="question7_true" name="question7" type="radio" [value]="true" [(ngModel)]="model7.model7_Q7" (click)="m7_Q7()"> <label for="question7_true">True</label><br/>
                                <input id="question7_false" name="question7" type="radio" [value]="false" [(ngModel)]="model7.model7_Q7" (click)="m7_Q7()"> <label for="question7_false">False</label><br/>
                                <div *ngIf="model7.model7_Q7 && model7_Q7" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                                    &nbsp;All tenants have a contract called a lease agreement. It may be written or oral. Written is recommended.
                                </div>
                                <div *ngIf="!model7.model7_Q7  && model7_Q7" style="background-color: rgba(0, 128, 0, 0.25);font-weight: bolder;">
                                    &nbsp;Correct!
                                </div>
                            </div>
                        </div>
                        <div *ngIf="flag" style="color:red" class="warning">
                            You must answer all questions correctly before moving on
                        </div>
                    </div>
                </div>
                <div class="container navigate-buttons">
                    <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                    <button *ngIf="activityOneCorrect()" type="button" class="btn waves-dark w-25" (click)="next() && resetFlag()">Next<i class="fas fa-angle-right ml-3"></i></button>
                    <button *ngIf="!activityOneCorrect()" type="button" class="btn waves-dark w-25" (click)="setFlag()" style="background-color: #ffd782;">Next<i class="fas fa-angle-right ml-3"></i></button>

                </div>
            </div>
        </section>


        <section>
            <div *ngIf="page===4">
                <div class="container module-content text-center content-box">
                    <h1>Watch the Video Below</h1>


                    <!-- EDIT PAST THIS LINE -->


                    <app-youtube-player #video src="https://www.youtube.com/embed/vAtlN9XNCV4" width="900" height="620" autoplay></app-youtube-player>


                    <!-- DON'T EDIT PAST THIS LINE -->


                </div>
                <div class="container navigate-buttons">
                    <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                    <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="video.duration / video.speed" [delay-until]="video.isCompleted" delay-tooltip="Watch the whole video to the end first.">Quiz<i class="fas fa-angle-right ml-3"></i></button>
                </div>
            </div>
        </section>

    </div>
</div>

<!-- Quiz Mode -->
<section *ngIf="page===5 && !courseComplete">
    <app-quiz-questions [questions]="questions" [moduleNumber]="6" (quizSubmitted)="handleQuiz($event)"></app-quiz-questions>
</section>

<!-- Course Complete -->
<section *ngIf="courseComplete">

    <!-- Message -->
    <div class="text-center">
        <h1 style="margin-bottom: 20px;">Congratulations! You've completed RentWise.</h1>
        <h4 style="margin-bottom: 60px;">Click 'Get Certificate' to receive your personalized certificate.</h4>

        <!-- Navigation Buttons -->
        <div class="certificate-btns">
            <button type="button" class="btn waves-dark w-25" (click)="courseComplete = false"><i class="fas fa-angle-left mr-3"></i>Back</button>
            <button type="button" class="btn waves-dark w-25" [routerLink]="'/certificate-rw'">Get Certificate<i class="fas fa-angle-right ml-3"></i></button>
        </div>
    </div>
</section>
